import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  
  {
    path: '/',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/congratulation',
    name: 'Congratulation',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "congratulation" */ '../views/Congratulation.vue')
  },
  {
    path: '/terms',
    name: 'Terms',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "terms" */ '../views/Terms.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "admin" */ '../views/Admin.vue')
  },
  {
    path: '/branchs',
    name: 'Branchs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "branchs" */ '../views/Empresas/branch.vue')
  },
  {
    path: '/addBranch',
    name: 'addBranch',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "addBranch" */ '../views/Empresas/addBranch.vue')
  },
  {
    path: '/editBranch',
    name: 'editBranch',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "editBranch" */ '../views/Empresas/editBranch.vue')
  },
  {
    path: '/commercial',
    name: 'ComercialEnterprise',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "commercialenterprise" */ '../views/Empresas/CommercialEnterprise.vue')
  },
  {
    path: '/paying',
    name: 'PayingEnterprise',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "PayingEnterprise" */ '../views/Empresas/PayingEnterprise.vue')
  },
  {
    path: '/addpaying',
    name: 'AddPayingEnterprise',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "AddPayingEnterprise" */ '../views/Empresas/AddPayingEnterprise.vue')
  },
  {
    path: '/editPaying',
    name: 'editEnterprise',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "editPayingEnterprise" */ '../views/Empresas/editEnterprise.vue')
  },
  {
    path: '/catalogue',
    name: 'CatalogueArea',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "CatalogueArea" */ '../views/Areas/CatalogueArea.vue')
  },
  {
    path: '/addArea',
    name: 'addArea',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "addArea" */ '../views/Areas/addArea.vue')
  },
  {
    path: '/addJob',
    name: 'addJob',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "addJob" */ '../views/Puestos/addJob.vue')
  },
  {
    path: '/level',
    name: 'Level',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Level" */ '../views/Level.vue')
  },
  {
    path: '/catalogueHolidays',
    name: 'CatalogueHolidays',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "CatalogueHolidays" */ '../views/Calendarios/CatalogueHolidays.vue')
  },
  {
    path: '/catalogueNonWorking',
    name: 'CatalogueNonWorking',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "CatalogueNonWorking" */ '../views/Calendarios/CatalogueNonWorking.vue')
  },
  {
    path: '/NonWorking',
    name: 'NonWorking',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "NonWorking" */ '../views/Calendarios/nonWorkingList.vue')
  },
  {
    path: '/calendar',
    name: 'Calendar',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Calendar" */ '../views/Calendarios/Calendar.vue')
  },
  {
    path: '/addcalendar',
    name: 'AddCalendar',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "AddCalendar" */ '../views/Calendarios/AddCalendar.vue')
  },
  {
    path: '/editcalendar',
    name: 'editCalendar',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "editCalendar" */ '../views/Calendarios/editCalendar.vue')
  },
  {
    path: '/areasList',
    name: 'areasList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "areasList" */ '../views/Areas/areasList.vue')
  },
  {
    path: '/job',
    name: 'job',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "job" */ '../views/Puestos/job.vue')
  },
  {
    path: '/jobList',
    name: 'jobList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "jobList" */ '../views/Puestos/jobList.vue')
  },
  {
    path: '/employees',
    name: 'employees',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "employees" */ '../views/Empleados/employees.vue')
  },
  
  {
    path: '/editEmployee',
    name: 'editEmployee',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "editEmployee" */ '../views/Empleados/editEmployee.vue')
  },
  {
    path: '/addEmployee',
    name: 'addEmployee',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "addEmployee" */ '../views/Empleados/addEmployee.vue')
  },
  {
    path: '/cfdi',
    name: 'cfdi',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "cfdi" */ '../views/Empleados/cfdi.vue')
  },
  {
    path: '/employeesList',
    name: 'employeesList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "employeesList" */ '../views/Empleados/employeesList.vue')
  },
  {
    path: '/connection',
    name: 'connection',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "connection" */ '../views/Conexion/connection.vue')
  },
  {
    path: '/addConnection',
    name: 'addConnection',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "connection" */ '../views/Conexion/add.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
